import { Config } from "../../../configurations/config";

export const MonthlyReimbursementFormAPIs = {
CreateMonthlyReimbursement: `${Config.server_url}${Config.api_prefix}/Reimbursement/Monthly`,
GetRemainingLimit:`${Config.server_url}${Config.api_prefix}/Reimbursement/GetOutstandingBalance`
};